/**
 * @desc 供应商账号列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierAccountMaster.pageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierAccount/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
